import Header from "../../Components/Header";
import ParticlesComponent from "../../Components/particles";
import Techs from "../../Components/Tech";

const PageTechs = () => {
  return (
    <div>
      <ParticlesComponent />
      <Header />
      <Techs />
    </div>
  );
};
export default PageTechs;
